export const NAME = "publishCrowdContentOrder";
export const DEFAULT_TAB = "PUBLISH_ORDER_MODAL_CONTENT_TAB";
export const SPECIAL_NOTES_TAB = "PUBLISH_ORDER_MODAL_SPECIAL_NOTES_TAB";
